/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/points-api/public';
}

/**
 * Parameters for `PointsApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
